import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { useCallback, useContext } from 'react';
import {
  CTA_GUARD_ACTION,
  CtaGuard,
  CtaGuardOutcome,
  CtaHandoff
} from '~/constants/common/ctaGuard';
import { useIsNative } from '~/context/common/DeviceContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import { sendMessageToNative } from '~/native/vdp/dispatchers';
import { logInfo } from '~/utilities/loggers';
import sendPurchaseMessageToNative from './sendPurchaseMessageToNative';

export default function useStartPurchase(
  url: string,
  eventPayload: PurchaseEventPayload
): () => void {
  const isNative = useIsNative();
  const { triggerEvent } = useContext(UserVehicleContext);

  return useCallback(() => {
    // On web this fires immediately before a full navigation, so it races RUM's batching timer.
    // The native branch has no unload and should be the more reliable of the two.
    logInfo(CTA_GUARD_ACTION, {
      guard: CtaGuard.StartPurchase,
      handoff: isNative ? CtaHandoff.Native : CtaHandoff.Navigation,
      outcome: CtaGuardOutcome.Attempt
    });

    if (isNative) {
      sendMessageToNative(DispatcherEvent.LeaveFullscreen, {}); // Ensure fullscreen is exited before starting purchase
      sendPurchaseMessageToNative(DispatcherEvent.StartPurchase, eventPayload);
    } else {
      triggerEvent.purchase();
      window.location.href = url;
    }
  }, [eventPayload, isNative, triggerEvent, url]);
}
